export enum WizardBlock {
  Root = 'Wizard',
}

export enum WizardElement {
  Stepper = 'stepper',
  Component = 'component',
  Actions = 'actions',
}
